import React from 'react';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import languageHelper from 'helpers/languages';
import PhoneField from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderAutoCompleteInputField from 'components/form/InputFields/RenderAutoCompleteInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { Field, isInvalid, reduxForm } from 'redux-form';

class ProfileForm extends React.Component {
    componentDidMount() {
        const {
            data,
            initialize,
        } = this.props;

        let values = {
            email: data.email,
            first_name: data.first_name,
            last_name: data.last_name,
            locale: data.locale,
            phone: data.phone,
        };

        initialize(values);
    }

    render() {
        const {
            data,
            handleSubmit,
            handleSubmitForm,
            submitting,
            translate,
        } = this.props;

        const {
            config: {
                language: {
                    supported: supportedLanguages,
                },
            },
        } = this.context;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section title={ translate('resources.users.forms.general') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.firstname') }
                                    name='first_name'
                                    type='text'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.lastname') }
                                    name='last_name'
                                    type='text'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    choices={ languageHelper.getLanguageChoices(supportedLanguages, translate) }
                                    component={ RenderAutoCompleteInputField }
                                    label={ translate('resources.users.fields.locale') }
                                    name='locale'
                                    optionText='label'
                                    optionValue='value'
                                    fullWidth={ true }
                                    startingValue= { data.locale }
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section title={ translate('resources.users.forms.contact') }>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ true }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.email') }
                                    name='email'
                                    type='email'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneField }
                                    fullWidth={ true }
                                    label={ translate('resources.users.fields.phonenumber') }
                                    name='phone'
                                    validate={ validations.required }
                                    type='text'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ submitting }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

ProfileForm.contextTypes = {
    config: PropTypes.object,
};

ProfileForm.propTypes = {
    data: PropTypes.object,
    handleSubmit: PropTypes.func,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        form: 'profile',
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.first_name) {
                errors.first_name = translate('forms.required');
            }

            if (!values.last_name) {
                errors.last_name = translate('forms.required');
            }

            if (!values.phone) {
                errors.phone = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(ProfileForm);



// WEBPACK FOOTER //
// ./src/pages/profile/ProfileForm.js